import { render, staticRenderFns } from "./SecoundCard.vue?vue&type=template&id=9979dd5c&scoped=true&"
import script from "./SecoundCard.vue?vue&type=script&lang=ts&"
export * from "./SecoundCard.vue?vue&type=script&lang=ts&"
import style0 from "./SecoundCard.vue?vue&type=style&index=0&id=9979dd5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9979dd5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCardTitle,VImg})
